(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chronos-product-conversion"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-chronos-product-conversion]').forEach(async (root) => {
      const status = root.querySelector('[data-review-status]');
      const countTemplate = root.dataset.countTemplate || '__COUNT__ reviews';
      const updateCard = (source, data) => {
        if (!data) return;
        const card = root.querySelector(`[data-compact-review="${source}"]`);
        if (!card) return;
        const rating = Number(data.rating || 0);
        const count = Number(data.reviewCount || 0);
        const ratingNode = card.querySelector('[data-review-rating]');
        const countNode = card.querySelector('[data-review-count]');
        if (ratingNode && rating > 0) ratingNode.textContent = rating.toFixed(1);
        if (countNode && count >= 0) countNode.textContent = countTemplate.replace('__COUNT__', String(count));
      };

      try {
        const response = await fetch(root.dataset.feedUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Review feed unavailable');
        const payload = await response.json();
        updateCard('google', payload.sources && payload.sources.google);
        updateCard('chrono24', payload.sources && payload.sources.chrono24);
        if (status) {
          status.textContent = payload.fresh === false
            ? (root.dataset.fallbackStatus || '')
            : (root.dataset.successStatus || '');
        }
      } catch (error) {
        if (status) status.textContent = root.dataset.fallbackStatus || '';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
